import React from "react";

function LoadingButton({
  loading,
  disabled,
  className,
  type = "button",
  children,
  loadingText,
  ...rest
}) {
  const isDisabled = Boolean(disabled || loading);

  return (
    <button
      type={type}
      className={className}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      {...rest}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            style={{ marginRight: 8 }}
          />
          {loadingText ?? children}
        </>
      ) : (
        children
      )}
    </button>
  );
}

export default LoadingButton;
